
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/pubmatic",
      function () {
        return require("private-next-pages/destinations/pubmatic.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/pubmatic"])
      });
    }
  